import { ClientEntity } from '../../clientModels'
import * as http from '../http'
import { buildApiUrl } from './apiUrl'

export function apiGetEngagementEntities(
  engagementId: number
): Promise<ClientEntity[]> {
  return http.get(buildApiUrl(`engagements/${engagementId}/entities`))
}
